/// <reference types="@angular/localize" />

import { enableProdMode, LOCALE_ID, ErrorHandler, importProvidersFrom } from '@angular/core';

import {environment} from './environments/environment';

import * as Sentry from "@sentry/angular";
import { AppComponent } from './app/app.component';
import { provideAnimations } from '@angular/platform-browser/animations';
import { CalendarModule } from 'angular-calendar';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CdsModule } from '@cds/angular';
import { ClarityModule } from '@clr/angular';
import { AppRoutingModule } from './app/app-routing.module';
import { withInterceptorsFromDi, provideHttpClient, HttpClient } from '@angular/common/http';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { Router, RouterModule } from '@angular/router';
import { SettingsService } from './app/core/services/settings.service';
import { LoginGuard, AdminOrManagerGuard, AdminGuard } from './app/core/guards/auth-guard.service';
import { httpInterceptorProviders } from './app/core/interceptors';
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {registerLocaleData} from "@angular/common";
import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';

if (environment.production) {
      enableProdMode();
      Sentry.init({
      dsn: "https://66f9b03f22ccc90b3f72068038c0b85d@o4503974940835840.ingest.sentry.io/4505788318351360",
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
      ],
      tracesSampleRate: 1.0,
      environment: environment.production ? "production" : "development",
      release: "maintenance-app-web@"+environment.VERSION,
        autoSessionTracking: true,

      // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ["localhost", /^https:\/\/maintenance.maurer-rides\.de\/api/],

      // Capture Replay for 10% of all sessions,
      // plus for 100% of sessions with an error
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,

    });
}
function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}

registerLocaleData(localeDe);
registerLocaleData(localeEn);

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(BrowserModule, AppRoutingModule, ClarityModule, CdsModule, ReactiveFormsModule, TranslateModule, CalendarModule, FormsModule, RouterModule, TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
        })),
        httpInterceptorProviders,
        LoginGuard,
        AdminOrManagerGuard,
        AdminGuard,
        {
            provide: LOCALE_ID,
            deps: [SettingsService],
            useFactory: (LocaleService: {
                locale: string;
            }) => LocaleService.locale
        },
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler({
                showDialog: false,
            }),
        },
        {
            provide: Sentry.TraceService,
            deps: [Router],
        },
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations(),
    ]
}).catch((err) => console.error(err));
